import http from "@/plugins/http";

export default {
  async getUserSites(params) {
    return http.get("/api/sites", {
      params,
    });
  },
  async createSite(data) {
    return http.post("/api/sites", data);
  },
  async deleteSite(id) {
    return http.delete(`/api/sites/${id}`);
  },
  async checkSite(id) {
    return http.post(`/api/sites/${id}/check`);
  },
};
